import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = '页面未找到 | 瓜田笔记';
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, follow');
  }, []);

  return (
    <div className="flex flex-1 flex-col bg-background-50">
      <main className="mx-auto flex w-full max-w-content flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-emotion-laugh-line text-3xl" />
        </span>
        <p className="mt-6 font-heading text-6xl font-bold text-background-300">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这块瓜田暂时是空的</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或已经被挪走了。回到首页，或者去全部趣闻里看看别处的热闹吧。
        </p>
        <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            回到首页
          </Link>
          <Link
            to="/stories"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览全部趣闻
          </Link>
        </div>
      </main>
    </div>
  );
}